import { render } from "./DocumentClassAttributesSubView.vue?vue&type=template&id=77ea1271&scoped=true&ts=true"
import script from "./DocumentClassAttributesSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassAttributesSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassAttributesSubView.vue?vue&type=style&index=0&id=77ea1271&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ea1271"]])

export default __exports__